import React from 'react';
import styled from 'styled-components';

type GisWordingContentProps = {
  className?: string;
};

const Col = styled.section`
  width: 100%;
  margin-top: 32px;
`;

const H1 = styled.h1`
  margin: 0 0 16px;
  font-size: 42px;
  line-height: 1.15;
  font-weight: 800;
  letter-spacing: -0.02em;

  @media (max-width: 767px) {
    font-size: 32px;
  }
`;

const P = styled.p`
  margin: 0 0 16px;
  font-size: 16px;
  line-height: 1.75;
  color: rgba(11, 18, 32, 0.88);
`;

export const GisWording: React.FC<GisWordingContentProps> = ({ className }) => (
      <Col className={className}>
        <H1>Wording for Specifying GIS</H1>
        <P>
          Architectural woodwork shall be manufactured and installed in accordance with the AWMAC
          Standards manual (current edition in effect at time of tender) and shall be subject to
          inspection by an appointed AWMAC Certified Inspector under the terms of the AWMAC Guarantee
          and Inspection Service (GIS). The Architectural Woodwork Manufacturer is responsible for
          completing all steps of the GIS process. Inspection costs shall be included in the tender
          price.{' '}
        </P>
        <P>
          Any work identified during execution that does not comply with AWMAC Standards (current
          edition in effect at time of tender) shall be replaced, reworked and/or refinished by the
          Manufacturer, at no additional cost to the Owner.
        </P>
        <P>
          If the Manufacturer is an AWMAC Manufacturer Member in good standing, an AWMAC Certificate of
          Guarantee shall be issued, valid for two (2) years from the date of issuance. The AWMAC
          Guarantee will cover replacing, reworking and/or refinishing deficient architectural
          woodwork due to faulty workmanship or defective materials supplied and installed by the
          Manufacturer Member. Should the Manufacturer Member fail to fulfill the obligations of the
          Guarantee, the Guarantee shall be honoured by the regional AWMAC Chapter and AWMAC National.
        </P>
        <P>
          If the Manufacturer is not an AWMAC Manufacturer Member in good standing, they must provide
          the Owner with a two (2) year maintenance bond, to the full value of the architectural
          woodwork contract. The bond shall be issued by a surety acceptable to the Owner and delivered
          prior to commencement of work. Manufacturers who are not AWMAC members in good standing are
          not eligible to receive the AWMAC Certificate of Guarantee.
        </P>
      </Col>
);
